import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/devices',
    name: 'DevicesView',
    component: () => import(/* webpackChunkName: "devicesView" */ '@/modules/devices/components/DevicesView'),
    meta: {
      moduleId: 'devices',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    props: true,
    beforeEnter: checkAuthenticated
  },
  {
    path: '/devices/:id',
    name: 'DevicesForm',
    component: () => import(/* webpackChunkName: "devicesForm" */ '@/modules/devices/components/DevicesForm'),
    props: true,
    beforeEnter: beforeEnterCheck,
  },
]
